module.exports = __webpack_public_path__ + "img/30-WHEEL.54c748b3.png";